import React from "react";
import { Text } from "@salestrak/ui";
import type { ActivityChange } from "../activity-types";
import { pluralize } from "../activity-utils";
import { MAX_DISPLAY_COUNT } from "../activity-types";

interface CustomFieldChunkProps {
  change: ActivityChange;
}

export function CustomFieldChunk({ change }: CustomFieldChunkProps) {
  const fields = change.fields ?? [];

  if (fields.length > 0 && fields.length <= MAX_DISPLAY_COUNT) {
    return (
      <Text size="sm">
        {change.action}{" "}
        <Text size="sm">
          custom {pluralize("field", { count: fields.length })}
        </Text>
        {fields.map((field, index) => (
          <Text key={`${field.customFieldId}-${index}`} size="sm">
            {" "}
            <Text size="sm">{field.name}</Text>
            {fields.length > 2 && index < fields.length - 1 ? "," : ""}
            {fields.length > 1 && index === fields.length - 2 ? " and" : ""}
          </Text>
        ))}
      </Text>
    );
  }

  if (fields.length > MAX_DISPLAY_COUNT) {
    return (
      <Text size="sm">
        {change.action} <Text size="sm">{fields.length} custom fields</Text>
      </Text>
    );
  }

  return null;
}
